import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  colorWhite: {
    color: theme.palette.common.white,
  },
  mainInformationHeader: {
    '&::before': {
      display: 'block',
      position: 'relative',
      top: -24,
      content: '""',
      width: 3,
      height: 0,
      transform: 'translateX(-50%)',
      borderLeft: '15px solid transparent',
      borderRight: '15px solid transparent',
      borderTop: '15px solid #EEEEEE',
    },
  },
  verticalDivider: {
    height: 100,
    width: 2,
    backgroundColor: theme.palette.common.white,
    margin: theme.spacing(0, 6),
  },
}));
